<div class="page">
  <div class="container">

    <h1>Privacy Policy</h1>

    <p>
      DailyCity respects the privacy of its users. We do not collect personal
      information unless it is voluntarily provided by users through forms
      such as the Contact Us page.
    </p>

    <h2>Information Collection</h2>
    <p>
      We may collect basic information such as name and email address only
      when users choose to submit it for communication or feedback purposes.
    </p>

    <h2>Third-Party Services</h2>
    <p>
      DailyCity may use third-party services such as Google AdSense to display
      advertisements. These services may use cookies and similar technologies
      to show ads based on user visits.
    </p>

    <p>
      Google, as a third-party vendor, uses cookies to serve ads on this website.
      Users may opt out of personalized advertising by visiting Google Ad
      Settings.
    </p>

    <h2>Cookies</h2>
    <p>
      Cookies are used to improve user experience and analyze website traffic.
      Users may choose to disable cookies through their browser settings.
    </p>

    <h2>Policy Updates</h2>
    <p>
      This privacy policy may be updated from time to time. Continued use of
      the website indicates acceptance of the updated policy.
    </p>

  </div>
</div>
